import { render, staticRenderFns } from "./messageupdate.vue?vue&type=template&id=192a7844&"
import script from "./messageupdate.vue?vue&type=script&lang=js&"
export * from "./messageupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports